import DirectionReveal from './direction-reveal';
export default (function () {
  var directionRevealDefault = DirectionReveal({
    selector: '.direction-reveal',
    itemSelector: '.direction-reveal__card',
    animationName: 'slide'
  });
});